import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const FixBackButton = ({ homePath = "/" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handlePopState = () => {
      if (window.history.length === 1 && location.pathname === homePath) {
        // If on the home page and no history, prevent navigation
        window.history.pushState(null, "", homePath);
      }
    };

    // Run on initial load
    handlePopState();

    // Listen for history changes
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate, location, homePath]);

  return null;
};

export default FixBackButton;
